"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class SearchResultPageStore {
    constructor() {
        Object.defineProperty(this, "selectedFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "showSummary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "summaryFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "filters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        (0, mobx_1.makeAutoObservable)(this);
    }
    setSelectedFilters(filters) {
        this.selectedFilters = filters;
    }
    setShowSummary(show) {
        this.showSummary = show;
    }
    setSummaryFilters(filters) {
        this.summaryFilters = filters;
    }
    setFilters(filters) {
        this.filters = filters;
    }
}
const searchStateResult = new SearchResultPageStore();
exports.default = searchStateResult;
